import _ from "lodash";
import { UserDataAdapter } from "../../adpters/UserDataAdapter";

export class CompanyDataAvailable {
    constructor() {}

    /**
     * @public
     * Retorna o source
     * @param {String} dataType
     * @returns {String}
     */
    getSource(dataType) {
        if (!dataType) return null;
        const sources = {
            accounting: "accounting",
            financial: "financial",
            personnel: "personnel",
            tax: "tax",
            "accounting-financial": "accounting"
        };

        return sources[dataType];
    }

    getSourcesAvailable(allAvailable) {
        if (!allAvailable) return [];

        let sourcesAvailable = [];

        const ids = Object.keys(allAvailable.date);

        for (let index = 0; index < ids.length; index++) {
            const available = allAvailable.date[ids[index]];
            const sources = Object.keys(available);
            sourcesAvailable = sourcesAvailable.concat(sources);
        }

        sourcesAvailable = _.uniq(sourcesAvailable);

        return sourcesAvailable || [];
    }

    /**
     * @public
     *
     * Retorna dados que a empresa possui
     * @param {Object} availableDates
     *
     * @returns {String|Null}
     */
    dataType(availableDates = {}, isAutorizedSource = true) {
        if (!availableDates) return null;

        if (_.isEmpty(availableDates.date)) return null;
        const sourcesAvailable = this.getSourcesAvailable(availableDates);
        const hasAccounting = sourcesAvailable.includes("accounting");

        const hasFinancial = sourcesAvailable.includes("financial");

        const hasPersonnel = sourcesAvailable.includes("personnel");

        const hasTax = sourcesAvailable.includes("tax");

        const hasScenario = _.some(
            availableDates.date,
            (available, scenario) =>
                scenario != "ORIGINAL" && !_.isEmpty(available)
        );

        const hasOriginal = _.some(
            availableDates.date,
            (available, scenario) =>
                scenario == "ORIGINAL" && !_.isEmpty(available)
        );

        const rolesUser = new UserDataAdapter().user()?.roles?.[0];

        if (rolesUser == "Pessoal") {
            if (hasPersonnel) return "personnel";
        } else if (rolesUser == "Fiscal" || rolesUser == "Pessoal e Fiscal") {
            if (hasTax) return "tax";
        } else if (rolesUser == "Financeiro") {
            if (hasTax) return "financial";
        }

        if (hasAccounting && hasFinancial && isAutorizedSource)
            return "accounting-financial";
        if (hasAccounting) {
            if (isAutorizedSource) return "accounting";
            else return "financial";
        }

        if (hasFinancial) return "financial";

        if (hasPersonnel) return "personnel";

        if (hasTax) return "tax";

        if (hasScenario) return "scenario";
    }

    /**
     * @public
     * Retorna quais sources a empresa possui
     * @param {Object}
     *
     * @return {Array}
     */
    getSources(availableData = {}) {
        if (!availableData) return null;
        const _hasAvailable = (sc) =>
            _.get(availableData.date.ORIGINAL, `${sc}.length`) ? true : false;

        return [
            {
                value: "accounting",
                label: "Contábil",
                available: _hasAvailable("accounting")
            },
            {
                value: "financial",
                label: "Financeiro",
                available: _hasAvailable("financial")
            },
            {
                value: "custom",
                label: "Customizado",
                available: _hasAvailable("custom")
            }
        ];
    }
}
